// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.query-details-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 16px;
  border-bottom: 1px solid #e8eef4;
  margin-bottom: 4px;
}
.query-details-card__header h3 {
  margin: 0;
  color: #172033;
  font-size: 18px;
}
.query-details-card__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0 24px;
  padding-top: 8px;
}
.query-details-card__item {
  min-width: 0;
  padding: 16px 0;
}
.query-details-card__message, .query-details-card__status {
  grid-column: 1/-1;
}
.query-details-card__message {
  width: 100%;
  padding: 16px 0 8px;
}
.query-details-card__message-box {
  width: 100%;
  min-height: 72px;
  padding: 16px 18px;
  margin-top: 4px;
  border: 1px solid #d6e4f5;
  border-radius: 10px;
  background: #f4f8fd;
  color: #1e293b;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.query-details-card__label-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.query-details-card__icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #eff6ff;
}
.query-details-card__icon {
  color: #075dc5;
}
.query-details-card__label {
  display: block;
  color: #004195;
  font-size: 15px;
  font-weight: 600;
}
.query-details-card__value {
  display: block;
  overflow-wrap: anywhere;
  color: #172033;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  padding-left: 42px;
}
.query-details-card__status {
  padding-top: 8px;
}
.query-details-card__status .ant-form-item {
  display: block;
  margin-bottom: 0;
  padding-left: 42px;
}
.query-details-card__status .ant-form-item-row,
.query-details-card__status .ant-row {
  display: block !important;
}
.query-details-card__status .ant-form-item-label {
  display: none;
}
.query-details-card__status .ant-form-item-control {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  width: 100% !important;
}
.query-details-card__status .ant-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
}
.query-details-card__status .ant-radio-wrapper {
  margin-right: 0;
}

.query-form-hidden-fields {
  display: none;
}

@media (max-width: 1024px) {
  .query-details-card__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .query-details-card__grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/QueryDetailsCard/queryDetailsCard.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AAAJ;AAEI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAAN;AAIE;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,gBAAA;AAFJ;AAKE;EACE,YAAA;EACA,eAAA;AAHJ;AAME;EAEE,iBAAA;AALJ;AAQE;EACE,WAAA;EACA,mBAAA;AANJ;AASE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAcE;EACE,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAeI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAbN;AAgBI;;EAEE,yBAAA;AAdN;AAiBI;EACE,aAAA;AAfN;AAkBI;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;AAhBN;AAmBI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAjBN;AAoBI;EACE,eAAA;AAlBN;;AAuBA;EACE,aAAA;AApBF;;AAuBA;EACE;IACE,gDAAA;EApBF;AACF;AAuBA;EACE;IACE,0BAAA;EArBF;AACF","sourcesContent":[".query-details-card {\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 0 16px;\n    border-bottom: 1px solid #e8eef4;\n    margin-bottom: 4px;\n\n    h3 {\n      margin: 0;\n      color: #172033;\n      font-size: 18px;\n    }\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 0 24px;\n    padding-top: 8px;\n  }\n\n  &__item {\n    min-width: 0;\n    padding: 16px 0;\n  }\n\n  &__message,\n  &__status {\n    grid-column: 1 / -1;\n  }\n\n  &__message {\n    width: 100%;\n    padding: 16px 0 8px;\n  }\n\n  &__message-box {\n    width: 100%;\n    min-height: 72px;\n    padding: 16px 18px;\n    margin-top: 4px;\n    border: 1px solid #d6e4f5;\n    border-radius: 10px;\n    background: #f4f8fd;\n    color: #1e293b;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 1.6;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n  }\n\n  &__label-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n  }\n\n  &__icon-box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    background: #eff6ff;\n  }\n\n  &__icon {\n    color: #075dc5;\n  }\n\n  &__label {\n    display: block;\n    color: #004195;\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  &__value {\n    display: block;\n    overflow-wrap: anywhere;\n    color: #172033;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.5;\n    padding-left: 42px;\n  }\n\n  &__status {\n    padding-top: 8px;\n\n    .ant-form-item {\n      display: block;\n      margin-bottom: 0;\n      padding-left: 42px;\n    }\n\n    .ant-form-item-row,\n    .ant-row {\n      display: block !important;\n    }\n\n    .ant-form-item-label {\n      display: none;\n    }\n\n    .ant-form-item-control {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n      width: 100% !important;\n    }\n\n    .ant-radio-group {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 12px 20px;\n    }\n\n    .ant-radio-wrapper {\n      margin-right: 0;\n    }\n  }\n}\n\n.query-form-hidden-fields {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .query-details-card__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .query-details-card__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
